import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {Budget} from '../../../interfaces';
import {Observable, Subject} from 'rxjs';
import {DataService} from '../../../services/data.service';
import {map, takeUntil} from 'rxjs/operators';
import {MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {AsyncPipe} from '@angular/common';



@Component({
    selector: 'app-budget-selector',
    imports: [
        MatFormField,
        MatLabel,
        MatAutocomplete,
        ReactiveFormsModule,
        MatAutocompleteTrigger,
        MatOption,
        AsyncPipe,
        MatInput
    ],
    template: `
        <mat-form-field style="width: 100%">
            <mat-label>Budget Nr.</mat-label>
            <input matInput type="text" [formControl]="formControl" [matAutocomplete]="auto" [required]="!!required"/>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                @for (budget of (budgetsList$ | async); track budget) {
                    <mat-option [value]="budget">
                        {{ budget.budgetNr }}
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>
    `
})
export class BudgetSelectorComponent implements OnDestroy {

    formControl: UntypedFormControl = new UntypedFormControl(null);

    @Input() required: boolean;
    @Output() validityChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() budgetChange: EventEmitter<Budget | null> = new EventEmitter<Budget | null>();

    budgetsList$: Observable<Budget[]>;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(
        private dataService: DataService
    ) {
        this.budgetsList$ = this.dataService.getBudgetList();
        this.formControl.statusChanges.pipe(
            takeUntil(this.unsubscribe$),
            map(v => v === 'VALID')
        ).subscribe(this.validityChange);

        this.formControl.valueChanges.pipe(
            takeUntil(this.unsubscribe$),
            map(v => typeof v === 'object' ? v : null)
        ).subscribe(this.budgetChange);
    }

    ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    displayFn(budget: Budget) {
        return budget ? budget.budgetNr : '';
    }
}
